<template>
  <standard-layout>
    <template v-slot:heading>
      <sakali-header title="TeamAndCoachSearchTest"/>
    </template>
    <template v-slot:main>
      Team oder Trainer suchen
      <team-and-coach-search-input/>
      Testtext, um zu sehen, dass combo als overlay kommt
    </template>
  </standard-layout>
</template>

<script>
import TeamAndCoachSearchInput from "@/components/TeamAndCoachSearchInput";
import StandardLayout from "@/layouts/StandardLayout";

export default {
  data() {
    return {}
  },
  components: {TeamAndCoachSearchInput, StandardLayout}
}
</script>